import React from 'react';
import './Footer.css'
import { ReactComponent as LivelyLogo } from '../../../assets/logos/lively-bbyh-logo-light.svg'
import { ReactComponent as CirclePhoneLogo } from '../../../assets/icons/svg/circle-phone.svg'
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Stack } from 'react-bootstrap';

function Footer() {
  
  const { t } = useTranslation(); 
  return (
      <>
          <Container fluid className="footer-container">
              <Row className="footer-top-container py-3 ps-1">
                  <Stack direction="horizontal">
                      <div className="footer-top-content">
                          <LivelyLogo />
                      </div>
                      <div className="footer-top-contact ms-auto pe-2">
                          <CirclePhoneLogo /> {t('lively_help_line')}
                      </div>
                  </Stack>
              </Row>

              <Row className="footer-bottom-container py-3">
                  <Col md="5">
                      <div className="left-footer-bottom-section">
                          &copy;{(new Date().getFullYear())} {t('footer.rights')}
                      </div>
                  </Col>
                  <Col>
                      <div className="right-footer-bottom-section">
                          <a href='/legal/privacy-policy'>{t('footer.privacy_policy')}</a> |
                          &nbsp;<a href='/legal/states-rights-privacy-policy'>{t('footer.states_privacy_policy')}</a> |
                          &nbsp;<a href='/legal/do-not-sell-my-personal-information'>{t('footer.do_not_sell')}</a> |
                          &nbsp;<a href='/legal/terms-of-use'>{t('footer.terms_of_use')}</a> |
                          &nbsp;<a href='/legal'>{t('footer.legal')}</a>
                      </div>
                  </Col>
              </Row>
          </Container>
      </>
  );
}

export default Footer;

